import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import PaperCard from '../components/PaperCard';
import Loading from '../components/Loading';
import ErrorMessage from '../components/ErrorMessage';
import { API_V1, apiGet } from '../lib/api';

const API = `${API_V1}/digests`;

export default function TopicsPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [topics, setTopics] = useState([]);
  const [papers, setPapers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');

  const activeTopic = searchParams.get('topic') || '';

  useEffect(() => {
    apiGet(`${API}/topic-names`)
      .then(d => setTopics(d.topics))
      .catch(e => setErr(e.message))
      .finally(() => setLoading(false));
  }, []);

  // 初次进入且无 ?topic= 时，默认选中首个主题（replace，不污染历史）
  useEffect(() => {
    if (topics.length > 0 && !activeTopic) {
      setSearchParams({ topic: topics[0].name }, { replace: true });
    }
  }, [topics, activeTopic, setSearchParams]);

  useEffect(() => {
    if (!activeTopic) return;
    setPapers([]);
    apiGet(`${API}/by-topic?topic=${encodeURIComponent(activeTopic)}`)
      .then(d => setPapers(d.papers))
      .catch(e => setErr(e.message));
  }, [activeTopic]);

  if (err) return <ErrorMessage message={err} />;
  if (loading) return <Loading />;

  return (
    <div className="page-with-side">
      <aside className="side-list">
        <div className="side-list-header">按主题</div>
        {topics.map(t => (
          <button
            key={t.name}
            className={`side-topic${activeTopic === t.name ? ' active' : ''}`}
            onClick={() => setSearchParams({ topic: t.name })}
          >
            <span className="side-topic-name">{t.name}</span>
            <span className="side-group-count">{t.count}</span>
          </button>
        ))}
      </aside>

      <section className="side-content">
        <header className="content-head">
          <h2>{activeTopic}</h2>
          <span className="content-sub">{papers.length} 篇解读</span>
        </header>
        {papers.length === 0 ? (
          <div className="empty-hint">该主题暂无解读</div>
        ) : (
          <div className="card-grid">
            {papers.map(p => <PaperCard key={p.id} paper={p} navIds={papers.map(x => x.id)} />)}
          </div>
        )}
      </section>
    </div>
  );
}
